export default __webpack_public_path__ + "static/media/favicon-lumpsum-refunds.01dd83a9.ico";